export default __webpack_public_path__ + "static/media/AneomiClosed5.38750497.jpg";